export enum InvoiceInputs {
	Number = "number",
	SerieNumber = "serieNumber",
	Key = "key",
	IssuanceDate = "issuanceDate",
}
